'use client'

import React from 'react'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { useLocale } from 'next-intl'

import { ToolbarLink } from '@/src/types/bottomToolbar'

interface BottomToolbarProps {
    currentValue: string
    toolbarLinks: ToolbarLink[]
    onNavigationChange: (value: string) => void
    topSlot?: React.ReactNode
}

const BottomToolbar: React.FC<BottomToolbarProps> = ({ currentValue, toolbarLinks, onNavigationChange, topSlot }) => {
    const locale = useLocale()
    const isRTL = locale === 'ar'

    const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
        onNavigationChange(newValue)
    }

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000
            }}
            elevation={3}
        >
            {topSlot}
            <BottomNavigation
                value={currentValue}
                onChange={handleChange}
                showLabels
                sx={{
                    px: 2,
                    py: 1.5,
                    direction: isRTL ? 'rtl' : 'ltr',
                    height: 'auto',
                    minHeight: 56
                }}
            >
                {toolbarLinks.map(link => (
                    <BottomNavigationAction
                        key={link.value}
                        label={link.label}
                        value={link.value}
                        icon={link.icon}
                        sx={{
                            minWidth: 'auto',
                            px: { xs: 1, sm: 2 },
                            position: 'relative',
                            zIndex: 1,
                            '& .MuiBottomNavigationAction-label': {
                                mt: isRTL ? 0 : 0.5,
                                fontWeight: 600,
                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                textAlign: 'center',
                                whiteSpace: 'nowrap', // Prevent text wrapping
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                                lineHeight: 1.2
                            },
                            '& .MuiBottomNavigationAction-icon': {
                                mb: 0.5
                            }
                        }}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    )
}

export { BottomToolbar }
export type { BottomToolbarProps }
